import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ProductionProductionResultActivity extends Component {

    constructor(props){
        super(props)
        this.RenderedComponent = import("app/components/Accounting/ProductionFacility/ProductionFacilityBrowser")
    }

    render() {
        return (
            <Activity 
                name="ProductionFacility"
                RenderedComponent={this.RenderedComponent}
                context="ProductionFacility"
            />
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ProductionProductionResultActivity)
